module.exports = __webpack_public_path__ + "static/media/baseline-exit.1f4b58a2.svg";